import { createRoute } from "../../utils";

import {
  notificationsSettingRoutesObj,
  notificationsSettingBreadcrumbs,
} from "./path";

import type { IRouteMetadataObj } from "@routes/types";

const notificationsSettingRouteMetadata: IRouteMetadataObj<
  typeof notificationsSettingRoutesObj
> = {
  edit: {
    title: "notificationsSetting",
    lazy: () => import("@/pages/commonPages/notificationsSetting/page"),
    mode: "edit",
    permission: "all",
  },
};

export const notificationsSettingRoutes = createRoute<
  typeof notificationsSettingRoutesObj
>(
  notificationsSettingRoutesObj,
  notificationsSettingRouteMetadata,
  notificationsSettingBreadcrumbs,
);
